import { Store, combine } from 'effector'
import { ToggleableDevice } from './togglable-device'
import { permissionsService } from './permissions.service'

export type DevicesState = {
  camera: {
    isEnabled: boolean
    stream: MediaStream | null
    devices: Array<MediaDeviceInfo>
    selectedDevice: MediaDeviceInfo | null
  }
  microphone: {
    isEnabled: boolean
    isReady: boolean
    stream: MediaStream | null
    devices: Array<MediaDeviceInfo>
    selectedDevice: MediaDeviceInfo | null
  }
}

class DevicesService {
  readonly camera: ToggleableDevice
  readonly microphone: ToggleableDevice

  readonly $state: Store<DevicesState>

  constructor() {
    this.microphone = new ToggleableDevice(
      'microphone',
      permissionsService.microphone
    )

    this.camera = new ToggleableDevice('camera', permissionsService.camera)

    this.$state = combine({
      camera: combine({
        isEnabled: combine(
          {
            deviceEnabled: this.camera.$deviceEnabled,
            deviceTrackEnabled: this.camera.$isWantEnabled,
            stream: this.camera.$stream
          },
          ({ deviceEnabled, deviceTrackEnabled, stream }) => {
            return !!deviceEnabled && !!deviceTrackEnabled && !!stream
          }
        ),
        devices: this.camera.$availableDevices,
        selectedDevice: this.camera.$selectedDevice,
        stream: this.camera.$stream
      }),
      microphone: combine({
        isEnabled: combine(
          {
            deviceEnabled: this.microphone.$deviceEnabled,
            deviceTrackEnabled: this.microphone.$isWantEnabled,
            stream: this.microphone.$stream
          },
          ({ deviceEnabled, deviceTrackEnabled, stream }) => {
            return !!deviceEnabled && !!deviceTrackEnabled && !!stream
          }
        ),
        isReady: this.microphone.$isReady,
        devices: this.microphone.$availableDevices,
        selectedDevice: this.microphone.$selectedDevice,
        stream: this.microphone.$stream
      })
    })

    // void this.fetchAvailableDevicesFx()

    // sample({
    //   clock: this.microphone.$selectedDevice,
    //   source: this.$availableDevices,
    //   filter: (available, device) => !!available.audio.length && !device,
    //   fn: (available) => available.audio[0],
    //   target: this.microphone.$selectedDevice
    // })
    //
    // sample({
    //   clock: this.camera.$selectedDevice,
    //   source: this.$availableDevices,
    //   filter: (available, device) => !!available.video.length && !device,
    //   fn: (available) => available.video[0],
    //   target: this.camera.$selectedDevice
    // })
  }
}

export const devicesService = new DevicesService()
